import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6c49e312 = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _fbfa44e8 = () => interopDefault(import('../pages/ai_photo_enhancer_app/index.vue' /* webpackChunkName: "pages/ai_photo_enhancer_app/index" */))
const _b8e88692 = () => interopDefault(import('../pages/demo/index.vue' /* webpackChunkName: "pages/demo/index" */))
const _c325ce4e = () => interopDefault(import('../pages/download.vue' /* webpackChunkName: "pages/download" */))
const _1c3a3238 = () => interopDefault(import('../pages/downloadApp.vue' /* webpackChunkName: "pages/downloadApp" */))
const _5443225c = () => interopDefault(import('../pages/explore.vue' /* webpackChunkName: "pages/explore" */))
const _d0efb7b6 = () => interopDefault(import('../pages/formula.vue' /* webpackChunkName: "pages/formula" */))
const _7860fd52 = () => interopDefault(import('../pages/image-page.vue' /* webpackChunkName: "pages/image-page" */))
const _095fe528 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _3aadc996 = () => interopDefault(import('../pages/terms-of-service.vue' /* webpackChunkName: "pages/terms-of-service" */))
const _d2a69518 = () => interopDefault(import('../pages/vip_discount.vue' /* webpackChunkName: "pages/vip_discount" */))
const _6919a1b4 = () => interopDefault(import('../pages/agent/chat-replay/index.vue' /* webpackChunkName: "pages/agent/chat-replay/index" */))
const _8042c658 = () => interopDefault(import('../pages/agent/quick-guide/index.vue' /* webpackChunkName: "pages/agent/quick-guide/index" */))
const _772c45d0 = () => interopDefault(import('../pages/campaign/photo-enhancer-mobile-sem.vue' /* webpackChunkName: "pages/campaign/photo-enhancer-mobile-sem" */))
const _227dc806 = () => interopDefault(import('../pages/demo/animate.vue' /* webpackChunkName: "pages/demo/animate" */))
const _42781b9c = () => interopDefault(import('../pages/demo/dir.vue' /* webpackChunkName: "pages/demo/dir" */))
const _025836a3 = () => interopDefault(import('../pages/demo/goart-general-article-layout.vue' /* webpackChunkName: "pages/demo/goart-general-article-layout" */))
const _142d886c = () => interopDefault(import('../pages/demo/goart-general-confirm-box.vue' /* webpackChunkName: "pages/demo/goart-general-confirm-box" */))
const _0ecf0f4e = () => interopDefault(import('../pages/demo/info.vue' /* webpackChunkName: "pages/demo/info" */))
const _cb8b3a68 = () => interopDefault(import('../pages/demo/mediaDemo.vue' /* webpackChunkName: "pages/demo/mediaDemo" */))
const _45ffa803 = () => interopDefault(import('../pages/demo/moreDemo.vue' /* webpackChunkName: "pages/demo/moreDemo" */))
const _5d09ce82 = () => interopDefault(import('../pages/demo/native.vue' /* webpackChunkName: "pages/demo/native" */))
const _5d608862 = () => interopDefault(import('../pages/demo/sdkDemo.vue' /* webpackChunkName: "pages/demo/sdkDemo" */))
const _03aee59c = () => interopDefault(import('../pages/demo/svg-pause.vue' /* webpackChunkName: "pages/demo/svg-pause" */))
const _5d4740b0 = () => interopDefault(import('../pages/demo/svg-play.vue' /* webpackChunkName: "pages/demo/svg-play" */))
const _2ae5c852 = () => interopDefault(import('../pages/demo/testMedia.vue' /* webpackChunkName: "pages/demo/testMedia" */))
const _655c5882 = () => interopDefault(import('../pages/demo/video-test-component.vue' /* webpackChunkName: "pages/demo/video-test-component" */))
const _b9be0598 = () => interopDefault(import('../pages/demo/videoPlay.vue' /* webpackChunkName: "pages/demo/videoPlay" */))
const _2588f8ed = () => interopDefault(import('../pages/desktop/Fotor_Qt_License_Notice.vue' /* webpackChunkName: "pages/desktop/Fotor_Qt_License_Notice" */))
const _e75b7a6a = () => interopDefault(import('../pages/desktop/FotorDesign_Qt_License_Notice.vue' /* webpackChunkName: "pages/desktop/FotorDesign_Qt_License_Notice" */))
const _dcbadccc = () => interopDefault(import('../pages/desktop/GoArt_Qt_License_Notice.vue' /* webpackChunkName: "pages/desktop/GoArt_Qt_License_Notice" */))
const _21ffb0fb = () => interopDefault(import('../pages/desktop/privacy-policy.vue' /* webpackChunkName: "pages/desktop/privacy-policy" */))
const _1c76ebe8 = () => interopDefault(import('../pages/desktop/term-of-service.vue' /* webpackChunkName: "pages/desktop/term-of-service" */))
const _fea6ab96 = () => interopDefault(import('../pages/facewow/privacy-policy.vue' /* webpackChunkName: "pages/facewow/privacy-policy" */))
const _91ec1df8 = () => interopDefault(import('../pages/facewow/privacy-policy-desktop.vue' /* webpackChunkName: "pages/facewow/privacy-policy-desktop" */))
const _68b6b812 = () => interopDefault(import('../pages/facewow/term-of-service.vue' /* webpackChunkName: "pages/facewow/term-of-service" */))
const _6dcad1e1 = () => interopDefault(import('../pages/facewow/term-of-service-desktop.vue' /* webpackChunkName: "pages/facewow/term-of-service-desktop" */))
const _1f12572d = () => interopDefault(import('../pages/goart/download.vue' /* webpackChunkName: "pages/goart/download" */))
const _18ce9104 = () => interopDefault(import('../pages/goart/download_v2.vue' /* webpackChunkName: "pages/goart/download_v2" */))
const _395e0664 = () => interopDefault(import('../pages/mobile/aboutsubscription.vue' /* webpackChunkName: "pages/mobile/aboutsubscription" */))
const _0e5a58d0 = () => interopDefault(import('../pages/mobile/agent-rule.vue' /* webpackChunkName: "pages/mobile/agent-rule" */))
const _4e4d6ba8 = () => interopDefault(import('../pages/mobile/ai-photo-enhancer.vue' /* webpackChunkName: "pages/mobile/ai-photo-enhancer" */))
const _fe718e32 = () => interopDefault(import('../pages/mobile/aigc_faq.vue' /* webpackChunkName: "pages/mobile/aigc_faq" */))
const _df102e72 = () => interopDefault(import('../pages/mobile/cancel-fotor-account.vue' /* webpackChunkName: "pages/mobile/cancel-fotor-account" */))
const _192a97a4 = () => interopDefault(import('../pages/mobile/clipfly_rule.vue' /* webpackChunkName: "pages/mobile/clipfly_rule" */))
const _002d9f76 = () => interopDefault(import('../pages/mobile/jump_schema.vue' /* webpackChunkName: "pages/mobile/jump_schema" */))
const _66f60054 = () => interopDefault(import('../pages/mobile/redeem_code.vue' /* webpackChunkName: "pages/mobile/redeem_code" */))
const _091ac846 = () => interopDefault(import('../pages/mobile/resource_detail.vue' /* webpackChunkName: "pages/mobile/resource_detail" */))
const _63baa837 = () => interopDefault(import('../pages/mobile/rule-description.vue' /* webpackChunkName: "pages/mobile/rule-description" */))
const _b48725be = () => interopDefault(import('../pages/mobile/tool_guide.vue' /* webpackChunkName: "pages/mobile/tool_guide" */))
const _caa838f8 = () => interopDefault(import('../pages/mobile/verif-user.vue' /* webpackChunkName: "pages/mobile/verif-user" */))
const _4951ebf4 = () => interopDefault(import('../pages/mobile/welcome.vue' /* webpackChunkName: "pages/mobile/welcome" */))
const _5e276162 = () => interopDefault(import('../pages/mobile/welcome-user.vue' /* webpackChunkName: "pages/mobile/welcome-user" */))
const _18555cc0 = () => interopDefault(import('../pages/mobile/welcome-user备份2023-6-14.vue' /* webpackChunkName: "pages/mobile/welcome-user备份2023-6-14" */))
const _359a9a7c = () => interopDefault(import('../pages/mobile/welcome备份2023-6-14.vue' /* webpackChunkName: "pages/mobile/welcome备份2023-6-14" */))
const _3764c481 = () => interopDefault(import('../pages/portraitme/privacy-policy-desktop.vue' /* webpackChunkName: "pages/portraitme/privacy-policy-desktop" */))
const _0e6b23f8 = () => interopDefault(import('../pages/portraitme/term-of-service-desktop.vue' /* webpackChunkName: "pages/portraitme/term-of-service-desktop" */))
const _6c84b70c = () => interopDefault(import('../pages/mobile/activity/christmas-2021.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2021" */))
const _6c92ce8d = () => interopDefault(import('../pages/mobile/activity/christmas-2022.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2022" */))
const _46402a11 = () => interopDefault(import('../pages/mobile/activity/christmas-2023/index.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2023/index" */))
const _49b6465c = () => interopDefault(import('../pages/mobile/activity/christmas-2024/index.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2024/index" */))
const _5c108aec = () => interopDefault(import('../pages/mobile/activity/free_code.vue' /* webpackChunkName: "pages/mobile/activity/free_code" */))
const _140dc77c = () => interopDefault(import('../pages/mobile/activity/function.vue' /* webpackChunkName: "pages/mobile/activity/function" */))
const _65ce170a = () => interopDefault(import('../pages/mobile/activity/function-bg-remove.vue' /* webpackChunkName: "pages/mobile/activity/function-bg-remove" */))
const _67968a22 = () => interopDefault(import('../pages/mobile/activity/halloween-2022.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2022" */))
const _ab67bc34 = () => interopDefault(import('../pages/mobile/activity/halloween-2023/index.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2023/index" */))
const _3f30d4a7 = () => interopDefault(import('../pages/mobile/activity/halloween-2024/index.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2024/index" */))
const _006e505f = () => interopDefault(import('../pages/mobile/activity/join_fotor_code.vue' /* webpackChunkName: "pages/mobile/activity/join_fotor_code" */))
const _3fc13d42 = () => interopDefault(import('../pages/mobile/activity/join_terabox_code.vue' /* webpackChunkName: "pages/mobile/activity/join_terabox_code" */))
const _76d853c4 = () => interopDefault(import('../pages/mobile/activity/price-increase-notification.vue' /* webpackChunkName: "pages/mobile/activity/price-increase-notification" */))
const _1fd2d38c = () => interopDefault(import('../pages/mobile/activity/share_free_code.vue' /* webpackChunkName: "pages/mobile/activity/share_free_code" */))
const _790dd8d4 = () => interopDefault(import('../pages/mobile/activity/share-2025/index.vue' /* webpackChunkName: "pages/mobile/activity/share-2025/index" */))
const _6d17c2cc = () => interopDefault(import('../pages/mobile/activity/valentine-2023.vue' /* webpackChunkName: "pages/mobile/activity/valentine-2023" */))
const _0cdb864c = () => interopDefault(import('../pages/mobile/activity/wallpaperdesign.vue' /* webpackChunkName: "pages/mobile/activity/wallpaperdesign" */))
const _1d9e62b1 = () => interopDefault(import('../pages/mobile/clipfly/downloadApp.vue' /* webpackChunkName: "pages/mobile/clipfly/downloadApp" */))
const _48cf0a71 = () => interopDefault(import('../pages/mobile/clipfly/helpCenter/index.vue' /* webpackChunkName: "pages/mobile/clipfly/helpCenter/index" */))
const _42561901 = () => interopDefault(import('../pages/mobile/clipfly/invite.vue' /* webpackChunkName: "pages/mobile/clipfly/invite" */))
const _fe878c60 = () => interopDefault(import('../pages/mobile/clipfly/song/index.vue' /* webpackChunkName: "pages/mobile/clipfly/song/index" */))
const _4ca408ce = () => interopDefault(import('../pages/mobile/clipfly/storys/index.vue' /* webpackChunkName: "pages/mobile/clipfly/storys/index" */))
const _76aa21d5 = () => interopDefault(import('../pages/mobile/clipfly/survey/index.vue' /* webpackChunkName: "pages/mobile/clipfly/survey/index" */))
const _13676cc8 = () => interopDefault(import('../pages/mobile/facewow/cancel-facewow-account.vue' /* webpackChunkName: "pages/mobile/facewow/cancel-facewow-account" */))
const _ef521c3c = () => interopDefault(import('../pages/mobile/goArt/ai-picture-faq.vue' /* webpackChunkName: "pages/mobile/goArt/ai-picture-faq" */))
const _72baf7dd = () => interopDefault(import('../pages/mobile/goArt/ai-picture-from-picutre.vue' /* webpackChunkName: "pages/mobile/goArt/ai-picture-from-picutre" */))
const _c008fb6a = () => interopDefault(import('../pages/mobile/goArt/blockInfo.vue' /* webpackChunkName: "pages/mobile/goArt/blockInfo" */))
const _4fc06fcc = () => interopDefault(import('../pages/mobile/goArt/cancel-account.vue' /* webpackChunkName: "pages/mobile/goArt/cancel-account" */))
const _e79bee72 = () => interopDefault(import('../pages/mobile/goArt/exchange-code.vue' /* webpackChunkName: "pages/mobile/goArt/exchange-code" */))
const _6331246e = () => interopDefault(import('../pages/mobile/goArt/invite.vue' /* webpackChunkName: "pages/mobile/goArt/invite" */))
const _a2067398 = () => interopDefault(import('../pages/mobile/goArt/invite-2024.vue' /* webpackChunkName: "pages/mobile/goArt/invite-2024" */))
const _06261adc = () => interopDefault(import('../pages/mobile/goArt/invite-blind-box/index.vue' /* webpackChunkName: "pages/mobile/goArt/invite-blind-box/index" */))
const _ab7b9000 = () => interopDefault(import('../pages/mobile/goArt/privacy_en.vue' /* webpackChunkName: "pages/mobile/goArt/privacy_en" */))
const _64791ff6 = () => interopDefault(import('../pages/mobile/goArt/privacy_zh.vue' /* webpackChunkName: "pages/mobile/goArt/privacy_zh" */))
const _11559f13 = () => interopDefault(import('../pages/mobile/goArt/sdk_zh.vue' /* webpackChunkName: "pages/mobile/goArt/sdk_zh" */))
const _7bf79a1a = () => interopDefault(import('../pages/mobile/goArt/services_en.vue' /* webpackChunkName: "pages/mobile/goArt/services_en" */))
const _4efff171 = () => interopDefault(import('../pages/mobile/goArt/services_en_v2.vue' /* webpackChunkName: "pages/mobile/goArt/services_en_v2" */))
const _4f0e08f2 = () => interopDefault(import('../pages/mobile/goArt/services_en_v3.vue' /* webpackChunkName: "pages/mobile/goArt/services_en_v3" */))
const _c10e5bc2 = () => interopDefault(import('../pages/mobile/goArt/services_zh.vue' /* webpackChunkName: "pages/mobile/goArt/services_zh" */))
const _353b1464 = () => interopDefault(import('../pages/mobile/goArt/user/index.vue' /* webpackChunkName: "pages/mobile/goArt/user/index" */))
const _40d67194 = () => interopDefault(import('../pages/mobile/goArt/work/index.vue' /* webpackChunkName: "pages/mobile/goArt/work/index" */))
const _72dfdfd5 = () => interopDefault(import('../pages/mobile/helper/android_vip_upgrade.vue' /* webpackChunkName: "pages/mobile/helper/android_vip_upgrade" */))
const _69cf28fe = () => interopDefault(import('../pages/mobile/helper/beauty-camera.vue' /* webpackChunkName: "pages/mobile/helper/beauty-camera" */))
const _034b5c7d = () => interopDefault(import('../pages/mobile/helper/center/index.vue' /* webpackChunkName: "pages/mobile/helper/center/index" */))
const _6e5501b0 = () => interopDefault(import('../pages/mobile/helper/center2.vue' /* webpackChunkName: "pages/mobile/helper/center2" */))
const _7773f162 = () => interopDefault(import('../pages/mobile/helper/upgrade-android-to-ios.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-android-to-ios" */))
const _7f19a391 = () => interopDefault(import('../pages/mobile/helper/upgrade-android-to-mac.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-android-to-mac" */))
const _2c16655a = () => interopDefault(import('../pages/mobile/helper/upgrade-ios-to-android.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-ios-to-android" */))
const _45e59233 = () => interopDefault(import('../pages/mobile/helper/upgrade-ios-to-mac.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-ios-to-mac" */))
const _0049d4a5 = () => interopDefault(import('../pages/mobile/helper/vip_upgrade.vue' /* webpackChunkName: "pages/mobile/helper/vip_upgrade" */))
const _10bf13fc = () => interopDefault(import('../pages/mobile/helper/what-new.vue' /* webpackChunkName: "pages/mobile/helper/what-new" */))
const _3bcf235e = () => interopDefault(import('../pages/mobile/activity/aigc/ai-cartoonizer.vue' /* webpackChunkName: "pages/mobile/activity/aigc/ai-cartoonizer" */))
const _defb54ca = () => interopDefault(import('../pages/mobile/activity/aigc/ai-ideal-mate.vue' /* webpackChunkName: "pages/mobile/activity/aigc/ai-ideal-mate" */))
const _bed83ba6 = () => interopDefault(import('../pages/mobile/activity/aigc/ai-sing.vue' /* webpackChunkName: "pages/mobile/activity/aigc/ai-sing" */))
const _41f7dab4 = () => interopDefault(import('../pages/mobile/clipfly/activity/rule.vue' /* webpackChunkName: "pages/mobile/clipfly/activity/rule" */))
const _1d514603 = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/index.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/index" */))
const _41d9728c = () => interopDefault(import('../pages/mobile/goArt/activity/new-self/index.vue' /* webpackChunkName: "pages/mobile/goArt/activity/new-self/index" */))
const _70181f0a = () => interopDefault(import('../pages/mobile/goArt/activity/valentines_day.vue' /* webpackChunkName: "pages/mobile/goArt/activity/valentines_day" */))
const _aeaf71f8 = () => interopDefault(import('../pages/mobile/goArt/digital-collection/user-list.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/user-list" */))
const _23cb9363 = () => interopDefault(import('../pages/mobile/goArt/invite-blind-box/Invited-friends.vue' /* webpackChunkName: "pages/mobile/goArt/invite-blind-box/Invited-friends" */))
const _5f658c56 = () => interopDefault(import('../pages/mobile/goArt/invite-blind-box/lucky-draw-record.vue' /* webpackChunkName: "pages/mobile/goArt/invite-blind-box/lucky-draw-record" */))
const _c54d54bc = () => interopDefault(import('../pages/mobile/goArt/nft/casting-instructions.vue' /* webpackChunkName: "pages/mobile/goArt/nft/casting-instructions" */))
const _d065582e = () => interopDefault(import('../pages/mobile/goArt/nft/helpCenter.vue' /* webpackChunkName: "pages/mobile/goArt/nft/helpCenter" */))
const _6bf411c2 = () => interopDefault(import('../pages/mobile/goArt/nft/how-to-check-nft-on-opensea.vue' /* webpackChunkName: "pages/mobile/goArt/nft/how-to-check-nft-on-opensea" */))
const _6540219f = () => interopDefault(import('../pages/mobile/goArt/nft/how-to-view-nft-works-in-opensea.vue' /* webpackChunkName: "pages/mobile/goArt/nft/how-to-view-nft-works-in-opensea" */))
const _38d400ee = () => interopDefault(import('../pages/mobile/goArt/nft/news/index.vue' /* webpackChunkName: "pages/mobile/goArt/nft/news/index" */))
const _e1ea36e2 = () => interopDefault(import('../pages/mobile/goArt/nft/what-is-encrypted-wallet.vue' /* webpackChunkName: "pages/mobile/goArt/nft/what-is-encrypted-wallet" */))
const _55bf3480 = () => interopDefault(import('../pages/mobile/activity/halloween-2024/views/centerPage.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2024/views/centerPage" */))
const _2304568c = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/contribute.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/contribute" */))
const _3e96958d = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/info.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/info" */))
const _e2864420 = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/record.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/record" */))
const _378233e4 = () => interopDefault(import('../pages/mobile/goArt/activity/new-self/info.vue' /* webpackChunkName: "pages/mobile/goArt/activity/new-self/info" */))
const _7f33c0cf = () => interopDefault(import('../pages/mobile/goArt/digital-collection/product/all-series.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/product/all-series" */))
const _31b0e335 = () => interopDefault(import('../pages/mobile/goArt/nft/article/1.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/1" */))
const _31befab6 = () => interopDefault(import('../pages/mobile/goArt/nft/article/2.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/2" */))
const _31cd1237 = () => interopDefault(import('../pages/mobile/goArt/nft/article/3.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/3" */))
const _31db29b8 = () => interopDefault(import('../pages/mobile/goArt/nft/article/4.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/4" */))
const _31e94139 = () => interopDefault(import('../pages/mobile/goArt/nft/article/5.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/5" */))
const _31f758ba = () => interopDefault(import('../pages/mobile/goArt/nft/article/6.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/6" */))
const _5f015012 = () => interopDefault(import('../pages/mobile/goArt/nft/protocol/guidelines.vue' /* webpackChunkName: "pages/mobile/goArt/nft/protocol/guidelines" */))
const _2f678a74 = () => interopDefault(import('../pages/mobile/goArt/nft/protocol/guidelines_v2.vue' /* webpackChunkName: "pages/mobile/goArt/nft/protocol/guidelines_v2" */))
const _507f8643 = () => interopDefault(import('../pages/mobile/goArt/nft/protocol/permission.vue' /* webpackChunkName: "pages/mobile/goArt/nft/protocol/permission" */))
const _39f1f95e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _35b34d0a = () => interopDefault(import('../pages/mobile/goArt/digital-collection/mine/_id.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/mine/_id" */))
const _7f7e863e = () => interopDefault(import('../pages/mobile/goArt/digital-collection/product/_id.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/product/_id" */))
const _52805031 = () => interopDefault(import('../pages/mobile/goArt/nft/news/_id.vue' /* webpackChunkName: "pages/mobile/goArt/nft/news/_id" */))
const _acde973a = () => interopDefault(import('../pages/mobile/open-app/_position.vue' /* webpackChunkName: "pages/mobile/open-app/_position" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _6c49e312,
    name: "404"
  }, {
    path: "/ai_photo_enhancer_app",
    component: _fbfa44e8,
    name: "ai_photo_enhancer_app"
  }, {
    path: "/demo",
    component: _b8e88692,
    name: "demo"
  }, {
    path: "/download",
    component: _c325ce4e,
    name: "download"
  }, {
    path: "/downloadApp",
    component: _1c3a3238,
    name: "downloadApp"
  }, {
    path: "/explore",
    component: _5443225c,
    name: "explore"
  }, {
    path: "/formula",
    component: _d0efb7b6,
    name: "formula"
  }, {
    path: "/image-page",
    component: _7860fd52,
    name: "image-page"
  }, {
    path: "/privacy-policy",
    component: _095fe528,
    name: "privacy-policy"
  }, {
    path: "/terms-of-service",
    component: _3aadc996,
    name: "terms-of-service"
  }, {
    path: "/vip_discount",
    component: _d2a69518,
    name: "vip_discount"
  }, {
    path: "/agent/chat-replay",
    component: _6919a1b4,
    name: "agent-chat-replay"
  }, {
    path: "/agent/quick-guide",
    component: _8042c658,
    name: "agent-quick-guide"
  }, {
    path: "/campaign/photo-enhancer-mobile-sem",
    component: _772c45d0,
    name: "campaign-photo-enhancer-mobile-sem"
  }, {
    path: "/demo/animate",
    component: _227dc806,
    name: "demo-animate"
  }, {
    path: "/demo/dir",
    component: _42781b9c,
    name: "demo-dir"
  }, {
    path: "/demo/goart-general-article-layout",
    component: _025836a3,
    name: "demo-goart-general-article-layout"
  }, {
    path: "/demo/goart-general-confirm-box",
    component: _142d886c,
    name: "demo-goart-general-confirm-box"
  }, {
    path: "/demo/info",
    component: _0ecf0f4e,
    name: "demo-info"
  }, {
    path: "/demo/mediaDemo",
    component: _cb8b3a68,
    name: "demo-mediaDemo"
  }, {
    path: "/demo/moreDemo",
    component: _45ffa803,
    name: "demo-moreDemo"
  }, {
    path: "/demo/native",
    component: _5d09ce82,
    name: "demo-native"
  }, {
    path: "/demo/sdkDemo",
    component: _5d608862,
    name: "demo-sdkDemo"
  }, {
    path: "/demo/svg-pause",
    component: _03aee59c,
    name: "demo-svg-pause"
  }, {
    path: "/demo/svg-play",
    component: _5d4740b0,
    name: "demo-svg-play"
  }, {
    path: "/demo/testMedia",
    component: _2ae5c852,
    name: "demo-testMedia"
  }, {
    path: "/demo/video-test-component",
    component: _655c5882,
    name: "demo-video-test-component"
  }, {
    path: "/demo/videoPlay",
    component: _b9be0598,
    name: "demo-videoPlay"
  }, {
    path: "/desktop/Fotor_Qt_License_Notice",
    component: _2588f8ed,
    name: "desktop-Fotor_Qt_License_Notice"
  }, {
    path: "/desktop/FotorDesign_Qt_License_Notice",
    component: _e75b7a6a,
    name: "desktop-FotorDesign_Qt_License_Notice"
  }, {
    path: "/desktop/GoArt_Qt_License_Notice",
    component: _dcbadccc,
    name: "desktop-GoArt_Qt_License_Notice"
  }, {
    path: "/desktop/privacy-policy",
    component: _21ffb0fb,
    name: "desktop-privacy-policy"
  }, {
    path: "/desktop/term-of-service",
    component: _1c76ebe8,
    name: "desktop-term-of-service"
  }, {
    path: "/facewow/privacy-policy",
    component: _fea6ab96,
    name: "facewow-privacy-policy"
  }, {
    path: "/facewow/privacy-policy-desktop",
    component: _91ec1df8,
    name: "facewow-privacy-policy-desktop"
  }, {
    path: "/facewow/term-of-service",
    component: _68b6b812,
    name: "facewow-term-of-service"
  }, {
    path: "/facewow/term-of-service-desktop",
    component: _6dcad1e1,
    name: "facewow-term-of-service-desktop"
  }, {
    path: "/goart/download",
    component: _1f12572d,
    name: "goart-download"
  }, {
    path: "/goart/download_v2",
    component: _18ce9104,
    name: "goart-download_v2"
  }, {
    path: "/mobile/aboutsubscription",
    component: _395e0664,
    name: "mobile-aboutsubscription"
  }, {
    path: "/mobile/agent-rule",
    component: _0e5a58d0,
    name: "mobile-agent-rule"
  }, {
    path: "/mobile/ai-photo-enhancer",
    component: _4e4d6ba8,
    name: "mobile-ai-photo-enhancer"
  }, {
    path: "/mobile/aigc_faq",
    component: _fe718e32,
    name: "mobile-aigc_faq"
  }, {
    path: "/mobile/cancel-fotor-account",
    component: _df102e72,
    name: "mobile-cancel-fotor-account"
  }, {
    path: "/mobile/clipfly_rule",
    component: _192a97a4,
    name: "mobile-clipfly_rule"
  }, {
    path: "/mobile/jump_schema",
    component: _002d9f76,
    name: "mobile-jump_schema"
  }, {
    path: "/mobile/redeem_code",
    component: _66f60054,
    name: "mobile-redeem_code"
  }, {
    path: "/mobile/resource_detail",
    component: _091ac846,
    name: "mobile-resource_detail"
  }, {
    path: "/mobile/rule-description",
    component: _63baa837,
    name: "mobile-rule-description"
  }, {
    path: "/mobile/tool_guide",
    component: _b48725be,
    name: "mobile-tool_guide"
  }, {
    path: "/mobile/verif-user",
    component: _caa838f8,
    name: "mobile-verif-user"
  }, {
    path: "/mobile/welcome",
    component: _4951ebf4,
    name: "mobile-welcome"
  }, {
    path: "/mobile/welcome-user",
    component: _5e276162,
    name: "mobile-welcome-user"
  }, {
    path: "/mobile/welcome-user%E5%A4%87%E4%BB%BD2023-6-14",
    component: _18555cc0,
    name: "mobile-welcome-user备份2023-6-14"
  }, {
    path: "/mobile/welcome%E5%A4%87%E4%BB%BD2023-6-14",
    component: _359a9a7c,
    name: "mobile-welcome备份2023-6-14"
  }, {
    path: "/portraitme/privacy-policy-desktop",
    component: _3764c481,
    name: "portraitme-privacy-policy-desktop"
  }, {
    path: "/portraitme/term-of-service-desktop",
    component: _0e6b23f8,
    name: "portraitme-term-of-service-desktop"
  }, {
    path: "/mobile/activity/christmas-2021",
    component: _6c84b70c,
    name: "mobile-activity-christmas-2021"
  }, {
    path: "/mobile/activity/christmas-2022",
    component: _6c92ce8d,
    name: "mobile-activity-christmas-2022"
  }, {
    path: "/mobile/activity/christmas-2023",
    component: _46402a11,
    name: "mobile-activity-christmas-2023"
  }, {
    path: "/mobile/activity/christmas-2024",
    component: _49b6465c,
    name: "mobile-activity-christmas-2024"
  }, {
    path: "/mobile/activity/free_code",
    component: _5c108aec,
    name: "mobile-activity-free_code"
  }, {
    path: "/mobile/activity/function",
    component: _140dc77c,
    name: "mobile-activity-function"
  }, {
    path: "/mobile/activity/function-bg-remove",
    component: _65ce170a,
    name: "mobile-activity-function-bg-remove"
  }, {
    path: "/mobile/activity/halloween-2022",
    component: _67968a22,
    name: "mobile-activity-halloween-2022"
  }, {
    path: "/mobile/activity/halloween-2023",
    component: _ab67bc34,
    name: "mobile-activity-halloween-2023"
  }, {
    path: "/mobile/activity/halloween-2024",
    component: _3f30d4a7,
    name: "mobile-activity-halloween-2024"
  }, {
    path: "/mobile/activity/join_fotor_code",
    component: _006e505f,
    name: "mobile-activity-join_fotor_code"
  }, {
    path: "/mobile/activity/join_terabox_code",
    component: _3fc13d42,
    name: "mobile-activity-join_terabox_code"
  }, {
    path: "/mobile/activity/price-increase-notification",
    component: _76d853c4,
    name: "mobile-activity-price-increase-notification"
  }, {
    path: "/mobile/activity/share_free_code",
    component: _1fd2d38c,
    name: "mobile-activity-share_free_code"
  }, {
    path: "/mobile/activity/share-2025",
    component: _790dd8d4,
    name: "mobile-activity-share-2025"
  }, {
    path: "/mobile/activity/valentine-2023",
    component: _6d17c2cc,
    name: "mobile-activity-valentine-2023"
  }, {
    path: "/mobile/activity/wallpaperdesign",
    component: _0cdb864c,
    name: "mobile-activity-wallpaperdesign"
  }, {
    path: "/mobile/clipfly/downloadApp",
    component: _1d9e62b1,
    name: "mobile-clipfly-downloadApp"
  }, {
    path: "/mobile/clipfly/helpCenter",
    component: _48cf0a71,
    name: "mobile-clipfly-helpCenter"
  }, {
    path: "/mobile/clipfly/invite",
    component: _42561901,
    name: "mobile-clipfly-invite"
  }, {
    path: "/mobile/clipfly/song",
    component: _fe878c60,
    name: "mobile-clipfly-song"
  }, {
    path: "/mobile/clipfly/storys",
    component: _4ca408ce,
    name: "mobile-clipfly-storys"
  }, {
    path: "/mobile/clipfly/survey",
    component: _76aa21d5,
    name: "mobile-clipfly-survey"
  }, {
    path: "/mobile/facewow/cancel-facewow-account",
    component: _13676cc8,
    name: "mobile-facewow-cancel-facewow-account"
  }, {
    path: "/mobile/goArt/ai-picture-faq",
    component: _ef521c3c,
    name: "mobile-goArt-ai-picture-faq"
  }, {
    path: "/mobile/goArt/ai-picture-from-picutre",
    component: _72baf7dd,
    name: "mobile-goArt-ai-picture-from-picutre"
  }, {
    path: "/mobile/goArt/blockInfo",
    component: _c008fb6a,
    name: "mobile-goArt-blockInfo"
  }, {
    path: "/mobile/goArt/cancel-account",
    component: _4fc06fcc,
    name: "mobile-goArt-cancel-account"
  }, {
    path: "/mobile/goArt/exchange-code",
    component: _e79bee72,
    name: "mobile-goArt-exchange-code"
  }, {
    path: "/mobile/goArt/invite",
    component: _6331246e,
    name: "mobile-goArt-invite"
  }, {
    path: "/mobile/goArt/invite-2024",
    component: _a2067398,
    name: "mobile-goArt-invite-2024"
  }, {
    path: "/mobile/goArt/invite-blind-box",
    component: _06261adc,
    name: "mobile-goArt-invite-blind-box"
  }, {
    path: "/mobile/goArt/privacy_en",
    component: _ab7b9000,
    name: "mobile-goArt-privacy_en"
  }, {
    path: "/mobile/goArt/privacy_zh",
    component: _64791ff6,
    name: "mobile-goArt-privacy_zh"
  }, {
    path: "/mobile/goArt/sdk_zh",
    component: _11559f13,
    name: "mobile-goArt-sdk_zh"
  }, {
    path: "/mobile/goArt/services_en",
    component: _7bf79a1a,
    name: "mobile-goArt-services_en"
  }, {
    path: "/mobile/goArt/services_en_v2",
    component: _4efff171,
    name: "mobile-goArt-services_en_v2"
  }, {
    path: "/mobile/goArt/services_en_v3",
    component: _4f0e08f2,
    name: "mobile-goArt-services_en_v3"
  }, {
    path: "/mobile/goArt/services_zh",
    component: _c10e5bc2,
    name: "mobile-goArt-services_zh"
  }, {
    path: "/mobile/goArt/user",
    component: _353b1464,
    name: "mobile-goArt-user"
  }, {
    path: "/mobile/goArt/work",
    component: _40d67194,
    name: "mobile-goArt-work"
  }, {
    path: "/mobile/helper/android_vip_upgrade",
    component: _72dfdfd5,
    name: "mobile-helper-android_vip_upgrade"
  }, {
    path: "/mobile/helper/beauty-camera",
    component: _69cf28fe,
    name: "mobile-helper-beauty-camera"
  }, {
    path: "/mobile/helper/center",
    component: _034b5c7d,
    name: "mobile-helper-center"
  }, {
    path: "/mobile/helper/center2",
    component: _6e5501b0,
    name: "mobile-helper-center2"
  }, {
    path: "/mobile/helper/upgrade-android-to-ios",
    component: _7773f162,
    name: "mobile-helper-upgrade-android-to-ios"
  }, {
    path: "/mobile/helper/upgrade-android-to-mac",
    component: _7f19a391,
    name: "mobile-helper-upgrade-android-to-mac"
  }, {
    path: "/mobile/helper/upgrade-ios-to-android",
    component: _2c16655a,
    name: "mobile-helper-upgrade-ios-to-android"
  }, {
    path: "/mobile/helper/upgrade-ios-to-mac",
    component: _45e59233,
    name: "mobile-helper-upgrade-ios-to-mac"
  }, {
    path: "/mobile/helper/vip_upgrade",
    component: _0049d4a5,
    name: "mobile-helper-vip_upgrade"
  }, {
    path: "/mobile/helper/what-new",
    component: _10bf13fc,
    name: "mobile-helper-what-new"
  }, {
    path: "/mobile/activity/aigc/ai-cartoonizer",
    component: _3bcf235e,
    name: "mobile-activity-aigc-ai-cartoonizer"
  }, {
    path: "/mobile/activity/aigc/ai-ideal-mate",
    component: _defb54ca,
    name: "mobile-activity-aigc-ai-ideal-mate"
  }, {
    path: "/mobile/activity/aigc/ai-sing",
    component: _bed83ba6,
    name: "mobile-activity-aigc-ai-sing"
  }, {
    path: "/mobile/clipfly/activity/rule",
    component: _41f7dab4,
    name: "mobile-clipfly-activity-rule"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign",
    component: _1d514603,
    name: "mobile-goArt-activity-ai-works-campaign"
  }, {
    path: "/mobile/goArt/activity/new-self",
    component: _41d9728c,
    name: "mobile-goArt-activity-new-self"
  }, {
    path: "/mobile/goArt/activity/valentines_day",
    component: _70181f0a,
    name: "mobile-goArt-activity-valentines_day"
  }, {
    path: "/mobile/goArt/digital-collection/user-list",
    component: _aeaf71f8,
    name: "mobile-goArt-digital-collection-user-list"
  }, {
    path: "/mobile/goArt/invite-blind-box/Invited-friends",
    component: _23cb9363,
    name: "mobile-goArt-invite-blind-box-Invited-friends"
  }, {
    path: "/mobile/goArt/invite-blind-box/lucky-draw-record",
    component: _5f658c56,
    name: "mobile-goArt-invite-blind-box-lucky-draw-record"
  }, {
    path: "/mobile/goArt/nft/casting-instructions",
    component: _c54d54bc,
    name: "mobile-goArt-nft-casting-instructions"
  }, {
    path: "/mobile/goArt/nft/helpCenter",
    component: _d065582e,
    name: "mobile-goArt-nft-helpCenter"
  }, {
    path: "/mobile/goArt/nft/how-to-check-nft-on-opensea",
    component: _6bf411c2,
    name: "mobile-goArt-nft-how-to-check-nft-on-opensea"
  }, {
    path: "/mobile/goArt/nft/how-to-view-nft-works-in-opensea",
    component: _6540219f,
    name: "mobile-goArt-nft-how-to-view-nft-works-in-opensea"
  }, {
    path: "/mobile/goArt/nft/news",
    component: _38d400ee,
    name: "mobile-goArt-nft-news"
  }, {
    path: "/mobile/goArt/nft/what-is-encrypted-wallet",
    component: _e1ea36e2,
    name: "mobile-goArt-nft-what-is-encrypted-wallet"
  }, {
    path: "/mobile/activity/halloween-2024/views/centerPage",
    component: _55bf3480,
    name: "mobile-activity-halloween-2024-views-centerPage"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign/contribute",
    component: _2304568c,
    name: "mobile-goArt-activity-ai-works-campaign-contribute"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign/info",
    component: _3e96958d,
    name: "mobile-goArt-activity-ai-works-campaign-info"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign/record",
    component: _e2864420,
    name: "mobile-goArt-activity-ai-works-campaign-record"
  }, {
    path: "/mobile/goArt/activity/new-self/info",
    component: _378233e4,
    name: "mobile-goArt-activity-new-self-info"
  }, {
    path: "/mobile/goArt/digital-collection/product/all-series",
    component: _7f33c0cf,
    name: "mobile-goArt-digital-collection-product-all-series"
  }, {
    path: "/mobile/goArt/nft/article/1",
    component: _31b0e335,
    name: "mobile-goArt-nft-article-1"
  }, {
    path: "/mobile/goArt/nft/article/2",
    component: _31befab6,
    name: "mobile-goArt-nft-article-2"
  }, {
    path: "/mobile/goArt/nft/article/3",
    component: _31cd1237,
    name: "mobile-goArt-nft-article-3"
  }, {
    path: "/mobile/goArt/nft/article/4",
    component: _31db29b8,
    name: "mobile-goArt-nft-article-4"
  }, {
    path: "/mobile/goArt/nft/article/5",
    component: _31e94139,
    name: "mobile-goArt-nft-article-5"
  }, {
    path: "/mobile/goArt/nft/article/6",
    component: _31f758ba,
    name: "mobile-goArt-nft-article-6"
  }, {
    path: "/mobile/goArt/nft/protocol/guidelines",
    component: _5f015012,
    name: "mobile-goArt-nft-protocol-guidelines"
  }, {
    path: "/mobile/goArt/nft/protocol/guidelines_v2",
    component: _2f678a74,
    name: "mobile-goArt-nft-protocol-guidelines_v2"
  }, {
    path: "/mobile/goArt/nft/protocol/permission",
    component: _507f8643,
    name: "mobile-goArt-nft-protocol-permission"
  }, {
    path: "/",
    component: _39f1f95e,
    name: "index"
  }, {
    path: "/mobile/goArt/digital-collection/mine/:id?",
    component: _35b34d0a,
    name: "mobile-goArt-digital-collection-mine-id"
  }, {
    path: "/mobile/goArt/digital-collection/product/:id?",
    component: _7f7e863e,
    name: "mobile-goArt-digital-collection-product-id"
  }, {
    path: "/mobile/goArt/nft/news/:id",
    component: _52805031,
    name: "mobile-goArt-nft-news-id"
  }, {
    path: "/mobile/open-app/:position?",
    component: _acde973a,
    name: "mobile-open-app-position"
  }, {
    path: "/mobile/clipfly/storys",
    component: _4ca408ce
  }, {
    path: "/mobile/clipfly/song",
    component: _fe878c60
  }, {
    path: "*",
    component: _6c49e312,
    name: "custom-404"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
